import { Fragment, useState, useEffect } from 'react'
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import AuthProvider from '../Authentication/authProvider'
import { Box, Typography } from '@mui/material'
import clsx from 'clsx'
import CrudView from '../../Utils/crud'
import { GetNotifcationFields, GetNoticeFields, GetAccountModules } from '../../REST/utilities'
import { AddAccount, GetAccount, GetExternalAccounts } from "../../REST/utilities";
import { GetById, UpdateItem, DeleteItem } from '../../REST/crud'
import PropertyTypes from '../Properties/types'
import PropertyAttributes from '../Properties/attributes'
import PropertyAreas from '../Properties/areas'
import Access from '../../Utils/authorize';
import Button from '@mui/material/Button';
import InspectionMaster from '../Inspection';
import MasterAssetList from '../../Modules/Asset/MasterAssetList';
import WorkorderMaster from '../Workorder';

import AddEditInspectionMaster from '../Inspection/forms/addeditinspectionMaster';
import AddEditMasterAsset from '../Asset/forms/addeditMasterAsset';
import AddEditWorkorderMaster from '../Workorder/forms/addeditworkorderMaster';

import Documents from './documents';
import Insurance from './insurance';
import InvoiceCycles from './invoiceCycles';
import PaymentTypes from './paymentType';
import Notifications from './notifications';
import Accounts from './accounts';
import Notices from './notices';
import SkuTypes from './skuType';
import Asset from '../Asset';
import SystemSettings from './systemsettings';
import CommunicationTemplates from './communicationTemplates';
import ImageLibrary from './imageLibrary';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import GroupIcon from '@mui/icons-material/Group';
import DescriptionIcon from '@mui/icons-material/Description';
import ShieldIcon from '@mui/icons-material/Shield';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import HomeIcon from '@mui/icons-material/Home';
import TuneIcon from '@mui/icons-material/Tune';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SendIcon from '@mui/icons-material/Send';
import SettingsIcon from '@mui/icons-material/Settings';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BuildIcon from '@mui/icons-material/Build';
import InventoryIcon from '@mui/icons-material/Inventory';
import EmailIcon from '@mui/icons-material/Email';
import ImageIcon from '@mui/icons-material/Image';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';


export default function Settings() {

    const navigate = useNavigate()
    const location = useLocation()

    const handleLink = (link) => navigate(link)

    const settingsItems = [
        { title: 'Accounts', link: '/settings/accounts', icon: <AccountCircleIcon /> },
        { title: 'External Accounts', link: '/settings/externalaccounts', icon: <GroupIcon /> },
        { title: 'Document Types', link: '/settings/documents', icon: <DescriptionIcon /> },
        { title: 'Insurance Types', link: '/settings/insurances', icon: <ShieldIcon /> },
        { title: 'Invoice Cycles', link: '/settings/invoiceCycles', icon: <ReceiptIcon /> },
        { title: 'Payment Types', link: '/settings/paymentTypes', icon: <PaymentIcon /> },
        { title: 'Notifications', link: '/settings/notifications', icon: <NotificationsIcon /> },
        { title: 'Notices', link: '/settings/notices', icon: <AnnouncementIcon /> },
        { title: 'Property Types', link: '/settings/types', icon: <HomeIcon /> },
        { title: 'Property Attributes', link: '/settings/attributes', icon: <TuneIcon /> },
        { title: 'Property Areas', link: '/settings/areas', icon: <LocationOnIcon /> },
        { title: 'Notifications Sent', link: '/settings/templates', icon: <SendIcon /> },
        { title: 'System Settings', link: '/settings/systemsettings', icon: <SettingsIcon /> },
        { title: 'Communication Templates', link: '/settings/communications', icon: <EmailIcon /> },
        { title: 'Image Library', link: '/settings/imagelibrary', icon: <ImageIcon /> },
        { title: 'Master Inspection', link: '/settings/inspection', icon: <AssignmentIcon /> },
        { title: 'Master Workorder', link: '/settings/workorder', icon: <BuildIcon /> },
        { title: 'Master Asset', link: '/settings/asset', icon: <InventoryIcon /> }
    ]

    console.log('Settings')

    return <Fragment>
        {location.pathname === '/settings' && (
            <div className='row' style={{ padding: '0 24px', rowGap: '20px' }}>
                {settingsItems.map((item, i) => (
                    <Box
                        key={i}
                        sx={{
                            ":hover": {
                                bgcolor: '#e9ecef'
                            }
                        }}
                        onClick={() => handleLink(item.link)}
                        className={clsx('col-sm-6', 'col-md-3', 'col-xs-12')}
                        style={{ zIndex: 99, cursor: 'pointer' }}
                        id={'each-form'}
                        title={item.title}
                    >
                        <div className={clsx('bg-light', 'rounded')} style={{ display: 'flex', alignItems: 'center', padding: '16px 16px 16px 8px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Box sx={{ 
                                    width: 56, 
                                    height: 56, 
                                    borderRadius: '50%',
                                    bgcolor: '#ede7f6',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    '& svg': { 
                                        fontSize: '2rem', 
                                        color: '#673ab7'
                                    }
                                }}>
                                    {item.icon}
                                </Box>
                                <Typography
                                    variant="subtitle1"
                                    sx={{ fontWeight: 600, minWidth: 0 }}
                                    noWrap
                                    title={item.title}
                                >
                                    {item.title}
                                </Typography>
                            </Box>
                        </div>
                    </Box>
                ))}
            </div>
        )}
        <Routes>
            <Route path='documents' element={<AuthProvider><Documents /></AuthProvider>} />
            <Route path='insurances' element={<AuthProvider><Insurance /></AuthProvider>} />
            <Route path='invoiceCycles' element={<AuthProvider><InvoiceCycles /></AuthProvider>} />
            <Route path='paymentTypes' element={<AuthProvider><PaymentTypes /></AuthProvider>} />
            <Route path='notifications' element={<AuthProvider><Notifications /></AuthProvider>} />
            <Route path='accounts' element={<AuthProvider><AccountsCrud /></AuthProvider>} />
            <Route path='externalaccounts' element={<AuthProvider><ExternalAccountsCrud /></AuthProvider>} />
            <Route path='notices' element={<AuthProvider><Notices /></AuthProvider>} />
            <Route path='attributes' element={<AuthProvider><PropertyAttributes /></AuthProvider>} />
            <Route path='areas' element={<AuthProvider><PropertyAreas /></AuthProvider>} />
            <Route path='types' element={<AuthProvider><PropertyTypes /></AuthProvider>} />
            <Route path='templates' element={<AuthProvider><TemplateCrud /></AuthProvider>} />
            <Route path='systemsettings' element={<AuthProvider><SystemSettings /></AuthProvider>} />
            <Route path='communications' element={<AuthProvider><CommunicationTemplates /></AuthProvider>} />
            <Route path='imagelibrary' element={<AuthProvider><ImageLibrary /></AuthProvider>} />
            <Route path='inspection'  element={<AuthProvider><InspectionMaster /></AuthProvider>} />
            <Route path='inspection/createInspection/:id'  element={<AuthProvider><AddEditInspectionMaster/></AuthProvider>} />
            <Route path='inspection/createInspection'  element={<AuthProvider><AddEditInspectionMaster/></AuthProvider>} />
            <Route path='workorder'  element={<AuthProvider><WorkorderMaster /></AuthProvider>} />
            <Route path="asset/createAsset" element={<AuthProvider><AddEditMasterAsset /></AuthProvider>} />
            <Route path='asset/createAsset/:id' element={<AuthProvider><AddEditMasterAsset /></AuthProvider>} />
            <Route path='asset'  element={<AuthProvider><Asset /></AuthProvider>} />
			<Route path='workorder/createWorkorder/:id'  element={<AuthProvider><AddEditWorkorderMaster/></AuthProvider>} />
            <Route path='workorder/createWorkorder'  element={<AuthProvider><AddEditWorkorderMaster/></AuthProvider>} />
        </Routes>
    </Fragment>
}

const TemplateCrud = () => {
    const schema = [
        { type: 'string', required: true, headerName: 'Emails', flex: 0.5, field: 'emails', grid: true, minVisible: 'xs' },
        { type: 'string', required: true, headerName: 'Subject', flex: 0.5, field: 'subject', grid: true, minVisible: 'md' },
        { type: 'date', required: true, headerName: 'Created On', flex: 0.5, field: 'createdAt', grid: true, minVisible: 'md' },
        { type: 'html', required: true, headerName: 'Body', flex: 0.5, field: 'html', grid: false },
    ]

    return <CrudView deletable={false} editable={true} schema={schema} title='Notifications Sent' type='Templates' pageSize={10} />
}
const AccountsCrud = () => {
    const [refresh, setRefresh] = useState(false)
    const [options, setOptions] = useState([])

    useEffect(() => {
        // Fetch available modules from API
        GetAccountModules().then(result => {
            const modules = result.data || []
            const formattedOptions = modules.map((x, idx) => {
                return { _id: idx, label: x, value: x }
            })
            setOptions(formattedOptions)
        }).catch(err => {
            console.log('Error fetching modules:', err)
            // Fallback to hardcoded list
            const fallback = ['Company', 'Tiedown', 'Property', 'Lease', 'Invoices', 'Reports', 'Waitlist', 'Settings', 'IncidentReports'].map((x, idx) => {
                return { _id: idx, label: x, value: x }
            })
            setOptions(fallback)
        })
    }, [])
 
    const schema = [
        { type: 'string', required: true, headerName: 'Email', flex: 0.5, field: 'email', grid: true },
        { type: 'boolean', headerName: 'Admin', flex: 0.15, field: 'admin', grid: true, valueGetter: (params) => params.row.admin ? 'Yes' : 'No' },
        {
            type: 'multiselect', required: true, headerName: 'Modules', flex: 1, options, field: 'modules', grid: true, renderCell: (params) => {
                return <div style={{ overflow: 'auto' }} className='d-flex'>
                    {params.row.modules.map(x => <div key={x} className='px-2'>{x}</div>)}
                </div>
            }
        }
    ]
 
    const handleAdmin = (params) => {
        const newadmin = params.row.admin ? false : true
        UpdateItem('Accounts', params.row.id,
         { ...params.row, admin: newadmin}).then(resp => {
            setRefresh(!refresh)
        }).catch(err => console.log)
 
    }
 
 
    return <CrudView schema={schema}  editable={Access.isAdmin('Settings')} deletable={false} title='Accounts' type='Accounts' pageSize={10} controls={[
        ]}
        services={{
            GetAll: GetAccount,
            GetId: GetById,
            Add: AddAccount,
            Update: UpdateItem,
            Delete: DeleteItem
        }} />
 
}

const ExternalAccountsCrud = () => {
    const [options, setOptions] = useState([])

    useEffect(() => {
        // Fetch available modules from API
        GetAccountModules().then(result => {
            const modules = result.data || []
            const formattedOptions = modules.map((x, idx) => {
                return { _id: idx, label: x, value: x }
            })
            setOptions(formattedOptions)
        }).catch(err => {
            console.log('Error fetching modules:', err)
            const fallback = ['Company', 'Tiedown', 'Property', 'Lease', 'Invoices', 'Reports', 'Waitlist', 'Settings', 'IncidentReports'].map((x, idx) => {
                return { _id: idx, label: x, value: x }
            })
            setOptions(fallback)
        })
    }, [])

    const schema = [
        { type: 'string', headerName: 'Email', flex: 0.5, field: 'email', grid: true },
        {
            type: 'multiselect', headerName: 'Modules', flex: 1, options, field: 'modules', grid: true, renderCell: (params) => {
                return <div style={{ overflow: 'auto' }} className='d-flex'>
                    {params.row.modules?.map(x => <div key={x} className='px-2'>{x}</div>)}
                </div>
            }
        }
    ]
 
    return <CrudView 
        schema={schema}   editable={false} deletable={false} title='External Accounts (Read Only)' 
        type='ExternalAccounts' pageSize={10} 
        services={{
            GetAll: GetExternalAccounts,GetId: GetById,Add: AddAccount,Update: UpdateItem,Delete: DeleteItem
        }} 
    />
}
